/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import MainContent from './components/MainContent';
import EnvironmentBanner from './components/EnvironmentBanner';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { RootProvider } from './contexts/RootContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LoanProvider } from './contexts/LoanContext';
import { Suspense, lazy } from 'react';
import useLazyComponent from './common/hooks/useLazyComponent';
import { LoginProvider } from './contexts/LoginContext';
import { BrwrProvider } from './contexts/BorrowerContext';
import { ViewingProvider } from './contexts/ViewingContext';
import { CommunicationProvider } from './contexts/CommunicationContext';
import { LoginAuditProvider } from './contexts/LoginAuditContext';
import useAngelAIWidget from './common/hooks/useAngelAIWidget';

const A11yCss = lazy(() => import('./components/A11yCss'));

const queryClient = new QueryClient();

const AngelAIWidget = () => {
  useAngelAIWidget();
  return null;
};

const App = () => {
  const A11yCssProps = {};
  const A11yCssLazy = useLazyComponent(A11yCss, <></>, `A11yCss: ${JSON.stringify(A11yCssProps)}`);

  return (
    <BrowserRouter basename={process.env[`REACT_APP_HOMEPAGE_PATH`]}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <LoginAuditProvider>
            <LoginProvider>
              <LoanProvider>
                <BrwrProvider>
                  <ViewingProvider>
                    <RootProvider>
                      <CommunicationProvider>
                        <AngelAIWidget />
                        {process.env.REACT_APP_A11Y && (
                          <Suspense fallback={<></>}>{/* <A11yCssLazy {...A11yCssProps} /> */}</Suspense>
                        )}
                        <EnvironmentBanner />
                        <MainContent />
                      </CommunicationProvider>
                    </RootProvider>
                  </ViewingProvider>
                </BrwrProvider>
              </LoanProvider>
            </LoginProvider>
          </LoginAuditProvider>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
};

export default App;
